import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastController } from '@ionic/angular';
import { Subscription, interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebserviceWorkerService {
  serviceSubscriptions: Subscription[] = [];

  constructor(
    public swUpdate: SwUpdate,
    private toastController: ToastController
  ) {
    this.initialize();
  }

  initialize() {
    // console.log(this.swUpdate.isEnabled, 'this.swUpdate.isEnabled');
    if (this.swUpdate.isEnabled) {
      // If service worker is enabled
      console.warn({ info: 'Service worker is running' });
      this.serviceSubscriptions.push(interval(50 * 1000).subscribe(() => this.swUpdate.checkForUpdate()));
      this.serviceSubscriptions.push(
        this.swUpdate.versionUpdates.subscribe(async (evt) => {
          if (evt.type === 'VERSION_READY') {
            console.warn({ info: 'New update is available' });
            await this.showUpdateNotification();
          }
        }),
      );
      this.serviceSubscriptions.push(
        this.swUpdate.unrecoverable.subscribe(evt => {
          console.warn({ info: 'App is in unrecoverable state. Reloading to avoid chunk load issue.' });
          //To do, may be prompt the user first. before loading the page
          window.location.reload();
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this.serviceSubscriptions?.forEach(x => x?.unsubscribe());
  }

  async showUpdateNotification() {
    const toast = await this.toastController.create({
      message: 'A new version is available. Refresh to update.',
      position: 'bottom',
      buttons: [
        {
          text: 'Refresh',
          role: 'refresh',
          handler: () => window.location.reload(),
        }
      ],
      keyboardClose: true,
      animated: true,
    });
    await toast.present();
    // Force dismissal on navigation
    // const navEventSubscription = this.router.events.subscribe(() => {
    //   toast.dismiss();
    //   navEventSubscription.unsubscribe();
    // });
  }
}
